import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/attachment-list-item/attachment-list-item.js';
      

      export interface Props {
     label?: string;
     index?: string;
     hasIndex?: boolean;
     hasLeadingIcon?: boolean;
     hasTag?: boolean;
     hasTimeDate?: boolean;
     date?: string;
     time?: string;
     hasTrailingAction?: boolean;
     showDivider?: boolean;
     amplified?: boolean;
     disabled?: boolean
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAttachmentListItem',
  props: {
    label: {},
    index: {},
    hasIndex: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    hasTag: { type: Boolean },
    hasTimeDate: { type: Boolean },
    date: {},
    time: {},
    hasTrailingAction: { type: Boolean },
    showDivider: { type: Boolean },
    amplified: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["attachment-item-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onAttachmentItemClick: (event: CustomEvent<{label: string}>) => emit('attachment-item-click', event as CustomEvent<{label: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-attachment-list-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})